import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys/pageSegmentLoadKey.ts';

// Inline Comments Highlights
export const INLINE_COMMENTS_HIGHLIGHTS_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric(
	{
		key: INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY,
		timings: [
			{
				key: 'fmp',
				endMark: 'fmp',
			},
			{
				key: 'tti',
				endMark: 'tti',
			},
			{
				key: 'highlightsRendered',
				endMark: 'highlightsRendered',
			},
		],
	},
);
